// extracted by mini-css-extract-plugin
export default {"card":"DgHUdzQ1jyih2afqHm8Z"};